import { LayoutGrid } from 'lucide-react';
import type { ElementType } from 'react';
import { cn } from '../ui/cn';

/**
 * Portal identity mark (PRO-0340 / ADR-014 Amendment 1). Shared visual treatment
 * for TAG Operations — used by the header wordmark link and the unauthenticated
 * landing card. The icon is decorative (`aria-hidden`); callers supply landmark
 * semantics (link `aria-label` or `titleAs="h1"` on the landing page).
 */
export function PortalIdentity({
  className,
  iconClassName,
  titleAs: Title = 'span',
  compact = false,
}: {
  className?: string;
  iconClassName?: string;
  titleAs?: ElementType;
  /** Header mobile: smaller title, hide subtitle to save horizontal space. */
  compact?: boolean;
}) {
  return (
    <div className={cn('inline-flex min-h-11 max-w-full items-center gap-3', className)}>
      <span
        aria-hidden
        className={cn(
          'flex shrink-0 items-center justify-center rounded-lg bg-primary shadow-sm',
          compact ? 'h-9 w-9 md:h-11 md:w-11' : 'h-11 w-11',
          iconClassName,
        )}
      >
        <LayoutGrid
          className={cn('text-primary-foreground', compact ? 'h-5 w-5 md:h-6 md:w-6' : 'h-6 w-6')}
          strokeWidth={2.25}
        />
      </span>
      <span className="flex min-w-0 flex-col justify-center leading-none">
        <Title
          className={cn(
            'm-0 truncate font-bold tracking-tight',
            compact ? 'text-base md:text-xl' : 'text-xl',
          )}
        >
          <span className="text-primary">TAG</span>
          <span className="text-text-primary"> Operations</span>
        </Title>
        <span
          className={cn(
            'mt-1 truncate text-xs font-semibold uppercase tracking-[0.14em] text-text-secondary',
            compact && 'hidden md:block',
          )}
        >
          The Aurora Group
        </span>
      </span>
    </div>
  );
}
